import solucaoMenu from './solucao/menu';
import vitrineMenu from './vitrine/menu';
import relatorioMenu from './relatorio/menu';

const menu = {
    label: 'Sol',
    icon: 'pi pi-sun',
    rules: [...solucaoMenu.rules, ...vitrineMenu.rules, ...relatorioMenu.rules],
    items: [
        {
            label: 'Cadastros',
            icon: 'pi pi-pencil',
            rules: ['SOL-001'],
            items: [solucaoMenu],
        },
        vitrineMenu,
        relatorioMenu,
    ],
};

export default menu;
